var React = require('react');

function NavIconsReferences (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"m19.94 21.91h-14.88v-20h8.94l6 6zm-13.81-1.07h12.73v-12.51l-5.34-5.33h-7.39z","key":0}),React.createElement("path",{"d":"m19.4 8.64h-6.19v-6.19h1.07v5.12h5.12z","key":1}),React.createElement("path",{"d":"m7.99 10.6h9.19v1.07h-9.19z","key":2}),React.createElement("path",{"d":"m7.99 7.58h3.92v1.07h-3.92z","key":3}),React.createElement("path",{"d":"m7.99 13.62h9.19v1.07h-9.19z","key":4}),React.createElement("path",{"d":"m7.99 16.63h9.19v1.07h-9.19z","key":5})]);
}

NavIconsReferences.defaultProps = {"viewBox":"0 0 24 24"};

module.exports = NavIconsReferences;

NavIconsReferences.default = NavIconsReferences;
